import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import Slider from '../components/Slider';

import ProductModal from '../components/ProductModal';
import ProductCard from '../components/ProductCard';
import IgCard from '../components/IgCard';
import NewsCard from '../components/NewsCard';
import { openModal } from '../components/Modal';

import graphic from '../assets/images/graphic.png';

import social from '../assets/mockData/images/social.jpg';

import { selectPreviewProduct } from '../actions/action';

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-right" />
    </div>
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick} aria-hidden>
      <i className="icon-arrow-left" />
    </div>
  );
};

const dataSource1 = [
  {
    title: '57th Bangkok Gold & Jewelry Fair 2016',
    id: 'aaa',
    img: 'https://source.unsplash.com/collection/190727/1600x900'
  },
  {
    title: '58th Bangkok Gold & Jewelry Fair 2016',
    id: 'bbb',
    img: 'https://source.unsplash.com/user/erondu/1600x900'
  },
  {
    title: '59th Bangkok Gold & Jewelry Fair 2016',
    id: 'ccc',
    img: 'https://source.unsplash.com/collection/190727/1600x900'
  },
  {
    title: '57th Bangkok Gold & Jewelry Fair 2016',
    id: 'aaa1',
    img: 'https://source.unsplash.com/user/erondu/1600x900'
  },
  {
    title: '58th Bangkok Gold & Jewelry Fair 2016',
    id: 'bbb2',
    img: 'https://source.unsplash.com/collection/190727/1600x900'
  },
  {
    title: '59th Bangkok Gold & Jewelry Fair 2016',
    id: 'ccc3',
    img: 'https://source.unsplash.com/user/erondu/1600x900'
  }
];

const mapStateToProps = ({
  allPage,
  products,
  settings,
  newsEvent,
  instagram
}) => {
  // console.log('mapStateToProps', newsEvent);
  const homeWP = _.map(allPage, (value, key) => {
    const content = _.find(value, (page) => {
      return _.get(page, 'slug') === 'home';
    });
    return {
      key,
      ...content
    };
  });

  const aboutusWP = _.map(allPage, (value, key) => {
    const content = _.get(
      _.find(value, page => _.get(page, 'slug') === 'about-us'),
      'acf',
      {}
    );
    return {
      key,
      ...content
    };
  });

  const productWP = _.map(allPage, (value, key) => {
    const content = _.find(value, page => _.get(page, 'slug') === 'products');
    return {
      key,
      ...content
    };
  });

  const newsWP = _.map(allPage, (value, key) => {
    const content = _.find(value, page => _.get(page, 'slug') === 'news-event');
    return {
      key,
      ...content
    };
  });

  const homeSection = _.keyBy(homeWP, 'key');

  const aboutSection = _.keyBy(aboutusWP, 'key');

  const productSection = _.keyBy(productWP, 'key');

  const newsSection = _.keyBy(newsWP, 'key');

  const newsData = _.keyBy(
    _.map(newsSection, (v, k) => {
      return {
        ...v,
        title: _.get(v, 'title.rendered'),
        allNews: _.orderBy(_.get(newsEvent, k), news => _.get(news, 'date'), [
          'asc'
        ])
      };
    }),
    'key'
  );

  const all = _.map(products, (items, key) => {
    const filterAccessories = _.partition(items, item =>
      _.get(item, 'acf.is_accessories', false));
    const accessoryItems = _.head(filterAccessories);
    const productItems = _.last(filterAccessories);
    const otherProduct = _.get(settings, 'other_product', {});
    const allProduct = [...productItems];
    const instagramData = _.map(instagram, (data) => {
      return {
        title: _.get(data, 'caption.text', ''),
        id: _.get(data, 'id', ''),
        url: _.get(data, 'images.standard_resolution.url', ''),
        comments: _.get(data, 'comments.count', 0),
        likes: _.get(data, 'likes.count', 0)
      };
    });
    return {
      key,
      data: {
        homeSection: _.get(homeSection, key),
        aboutSection: _.get(aboutSection, key),
        productSection: {
          title: _.get(productSection, `${key}.title.rendered`),
          allProduct,
          otherProduct,
          accessoryItems: _.head(accessoryItems)
        },
        newsSection: _.get(newsData, key),
        instagram: instagramData
      }
    };
  });
  return {
    content: _.keyBy(all, 'key'),
    catalog: _.get(settings, 'basic_catalog'),
    settings
  };
};

const actions = { selectPreviewProduct };

const mapDispatchToProps = (dispatch) => {
  return { actions: bindActionCreators(actions, dispatch) };
};
class Home extends Component {
  constructor(props) {
    super(props);
    this.newSlider = React.createRef();
    this.newSliderDrag = false;
  }

  handleOnClickNews = (id) => {
    const { history } = this.props;
    if (!this.newSliderDrag) {
      history.push(`/news-event/${id}`);
    }
  };

  handleOnClickProduct = (product) => {
    this.props.actions.selectPreviewProduct(product);
    openModal('modal-preview-gallery');
  };

  renderLastProduct = () => {
    const { content, language } = this.props;
    if (
      !_.get(content, [language, 'data', 'productSection', 'accessoryItems'])
    ) {
      return null;
    }
    return (
      <ProductCard
        img={_.get(content, [
          language,
          'data',
          'productSection',
          'accessoryItems',
          'acf',
          'cover_image',
          'url'
        ])}
        main={false}
        title={_.get(content, [
          language,
          'data',
          'productSection',
          'accessoryItems',
          'title',
          'rendered'
        ])}
        subTitle={_.get(content, [
          language,
          'data',
          'productSection',
          'accessoryItems',
          'acf',
          'product_code'
        ])}
        onClick={() =>
          this.handleOnClickProduct(_.get(content, [
            language,
            'data',
            'productSection',
            'accessoryItems'
          ]))
        }
      />
    );
  };

  renderProduct = () => {
    const { content, language } = this.props;
    const allProduct = _.get(
      content,
      `${language}.data.productSection.allProduct`,
      []
    );
    const sortProduct = _.orderBy(allProduct, ['acf.is_new_arrival'], ['desc']);
    return _.map(_.take(sortProduct, 6), (data, index) => {
      let className = 'wrap-product-card col-12 col-sm-12 col-md-6 col-lg-4';
      let productClassName = 'home -main';
      let main = false;
      if (index === 0) {
        className = 'wrap-product-card col-12';
        productClassName = 'head-product';
        main = true;
      }
      return (
        <div key={`${data.id}-${index}`} className={className}>
          <ProductCard
            className={productClassName}
            img={_.get(data, ['acf', 'cover_image', 'url'])}
            main={main}
            title={`${_.get(data, ['title', 'rendered'])}`}
            // title={_.get(data, ['title', 'rendered'])}
            subTitle={_.get(data, ['acf', 'product_code'])}
            onClick={() => this.handleOnClickProduct(data)}
          />
        </div>
      );
    });
  };

  renderInstagram = () => {
    const { content, getContentLanguage, settings, language } = this.props;
    const linkInstagram = _.get(
      settings,
      'social_instagram',
      'https://www.instagram.com'
    );
    const instagram = _.get(content, `${language}.data.instagram`, []);
    return (
      <div className="section-offical row no-gutters">
        <div className="col-12 offset-md-1 col-md-10">
          <div className="col offical-content">
            <h2 className="title">#BIGSILVER OFFICIAL</h2>
          </div>
          <div className="content-slider col">
            <Slider
              className="modal-slider offical"
              settings={{
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                nextArrow: <SampleNextArrow />,
                prevArrow: <SamplePrevArrow />,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      arrows: false
                    }
                  },
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      arrows: false
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                      arrows: false
                    }
                  }
                ]
              }}
              itemList={instagram}
              uiRenderer={({ url, comments, likes }) => (
                <IgCard src={url} comments={comments} likes={likes} />
              )}
            />
          </div>
          <div className="col news-all">
            <a
              className="lightGray"
              href={linkInstagram}
              target="_blank"
              rel="noopener noreferrer"
            >
              Follow us
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { content, getContentLanguage, settings, language } = this.props;

    const homeTextContent = _.get(
      content,
      `${language}.data.homeSection.content.rendered`
    );
    // console.log('render', content, _.get(content, `${language}.data`));
    return (
      <div className="home-page no-gutters">
        <div className="section-slide-product col-12 no-gutters">
          <div className="graphic">
            <img src={graphic} alt="" />
          </div>
          <Slider
            className="product-slider"
            settings={{
              dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              nextArrow: <SampleNextArrow />,
              prevArrow: <SamplePrevArrow />,
              responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    arrows: false
                  }
                }
              ]
            }}
            itemList={_.get(
              content,
              `${language}.data.homeSection.acf.banners.gallery`
            )}
            uiRenderer={(data, index) => (
              <div
                key={`banner-${index}`}
                className="wrap-img-slide no-gutters"
              >
                <div className="hold-img col-12 col-lg-10 ">
                  <img src={_.get(data, 'url')} alt="" />
                </div>
                <div className="text-slider" style={{ position: 'absolute' }}>
                  <h1
                    className="darkGray"
                    dangerouslySetInnerHTML={{
                      __html: _.get(
                        content,
                        `${language}.data.homeSection.acf.banners.caption`
                      )
                    }}
                  />
                </div>
              </div>
            )}
          />
        </div>

        <div className="section-about offset-lg-1 col-lg-11  m-bottom-100">
          <div className="wrap-about">
            <div className="about-content row no-gutters col-12 col-md-12 col-lg-9">
              <div className="history-img">
                <img
                  src={_.get(
                    content,
                    `${language}.data.aboutSection.history_background.url`
                  )}
                  alt=""
                />
              </div>
              <div className="offset-1 col-10 col-lg-8 history-text">
                <div className="text">
                  <h2 className="uppercase title m-bottom-40">
                    {' '}
                    {_.get(content, `${language}.data.aboutSection.title`)}
                  </h2>
                  <div className="paragraph">
                    <h3 className=" m-bottom-20">
                      {_.get(content, `${language}.data.aboutSection.tagline`)}
                    </h3>
                    <p
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: _.get(
                          content,
                          `${language}.data.aboutSection.content.0.paragraph`
                        )
                      }}
                    />
                  </div>
                  <div className="col-10 about-all">
                    <Link className="navGold" to="/about-us">
                      {getContentLanguage('explore')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-product row no-gutters">
          <div className="col-12 offset-md-1  col-md-10 no-gutters">
            <div className="graphic col-3">
              <img src={graphic} alt="" />
            </div>
            <div className="product-content">
              <h2 className="col-12 darkGray title m-bottom-40">
                {_.get(content, `${language}.data.productSection.title`)}
              </h2>

              {this.renderProduct()}
              <div className="wrap-product-card col-product col-12 col-sm-12 col-md-6 col-lg-4">
                {this.renderLastProduct()}
                <a
                  href={_.get(
                    content,
                    `${language}.data.productSection.otherProduct.url`
                  )}
                >
                  <ProductCard
                    titleBottom={_.get(
                      content,
                      `${language}.data.productSection.otherProduct.text`
                    )}
                    img={_.get(
                      content,
                      `${language}.data.productSection.otherProduct.image.url`
                    )}
                    main={false}
                  />
                </a>
              </div>

              <ProductModal
                name="modal-preview-gallery"
                getContentLanguage={getContentLanguage}
                language={language}
              />
              <div className="col-10 about-all">
                <Link className="navGold" to="/products">
                  {getContentLanguage('allProduct')}
                </Link>
              </div>
            </div>
          </div>
        </div>
        {/* {this.renderInstagram()} */}
        <div className="section-news-events row no-gutters">
          <div className="col-12 offset-md-1 col-md-10 no-gutters">
            <div className="col ffical-content">
              <h2
                className="whiteGray uppercase title"
                dangerouslySetInnerHTML={{
                  // __html: _.get(content, `${language}.data.newsSection.title`)
                  __html: _.get(content, `${language}.data.newsSection.title`)
                }}
              />
            </div>
            <div className="content-slider col">
              <Slider
                ref={this.newSlider}
                name="new-slider"
                className="modal-slider new-slider"
                onMouseDown={e => this.handleOnMouseDown(e)}
                settings={{
                  dots: false,
                  infinite: false,
                  speed: 500,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  autoplay: false,
                  variableWidth: false,
                  nextArrow: <SampleNextArrow />,
                  prevArrow: <SamplePrevArrow />,
                  beforeChange: () => (this.newSliderDrag = true),
                  afterChange: () => (this.newSliderDrag = false),
                  responsive: [
                    {
                      breakpoint: 1023,
                      settings: {
                        variableWidth: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false
                      }
                    },
                    {
                      breakpoint: 600,
                      settings: {
                        variableWidth: true,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        variableWidth: true,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false
                      }
                    }
                  ]
                }}
                // itemList={_.get(content, `${language}.data.newsSection.allNews.${language}`)}
                itemList={_.get(
                  content,
                  `${language}.data.newsSection.allNews`
                )}
                uiRenderer={(data) => {
                  return (
                    <React.Fragment key={`newsCard-${data.slug}`}>
                      <NewsCard
                        name={`newsCard-${data.slug}`}
                        className="home-newsCard"
                        title={_.get(data, 'title.rendered')}
                        img={_.get(data, ['acf', 'cover_image', 'url'])}
                        onClick={() => this.handleOnClickNews(data.slug)}
                      />
                    </React.Fragment>
                  );
                }}
              />
            </div>
            <div className="col news-all">
              <Link className="navGold" to="/news-event">
                {getContentLanguage('allNews')}
              </Link>
            </div>
          </div>
        </div>
        {homeTextContent && (
          <div className="section-seo-content row no-gutters">
            <div
              className="col-12 offset-md-1 col-md-10 no-gutters"
              dangerouslySetInnerHTML={{
                __html: homeTextContent
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/screens/Home.js